// Returns the piwik url
import env from "../utils/env";

const PIWIK_URL = "https://piwik.teladoc.com/ppms.php";

// Creates string flow-ui expects for piwik events
function createSearchParamsString(paramsObject) {
  const urlSearchParams = new URLSearchParams(paramsObject);
  const urlSeachString = urlSearchParams.toString();
  return `?${urlSeachString}`;
}

// builds the request body to send to piwik instance
function buildTrackingEventsRequestsBody(trackingEvents = []) {
  const auth_token = env("PIWIK_AUTH_TOKEN");
  const trackingEventParamsStrings = trackingEvents.map(
    createSearchParamsString
  );
  return { requests: trackingEventParamsStrings, auth_token };
}

// builds the tracking request body
function buildRequestBody(body) {
  const requestsBody = buildTrackingEventsRequestsBody(body);
  return JSON.stringify(requestsBody);
}

// Builds the post request
function buildPostRequest(body) {
  const method = "POST";
  return {
    method,
    body
  };
}

function buildRequest(trackingEvents) {
  const requestsBody = buildRequestBody(trackingEvents);
  return buildPostRequest(requestsBody);
}

function logTrackingEvents(trackingEvents) {
  const request = buildRequest(trackingEvents);
  const url = PIWIK_URL;
  return fetch(url, request).then(res => Promise.resolve(res.json()));
}

export default logTrackingEvents;

export {
  createSearchParamsString,
  buildRequestBody,
  buildTrackingEventsRequestsBody,
  buildPostRequest,
  buildRequest
};
